import { Component, ElementRef, inject, input, ViewChild } from '@angular/core';
import { UserAuthenticationService } from '../../../../../administration/src/lib/services/user-authentication.service';
import { NgClass } from '@angular/common';

@Component({
  selector: 'app-module-loader',
  imports: [NgClass],
  templateUrl: './module-loader.component.html',
  styleUrl: './module-loader.component.scss'
})
export class ModuleLoaderComponent {
  _UserAuthenticationService = inject(UserAuthenticationService);

  @ViewChild('moduleloader') moduleloader!: ElementRef;

  constructor() {
    setTimeout(() => {
      if (this.moduleloader) {
        this.moduleloader.nativeElement.classList.add('hidden');
        setTimeout(() => {
          this.moduleloader.nativeElement.remove();
        }, 500);
      }
    }, 1500);
  }
  LoadingDetails = this._UserAuthenticationService.UserSelectedModule;
}
